// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"Pca-z","disabled":"Qca-z","label":"Rca-z"};